import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { selfInvoiceDiscarded, selfInvoiceSent } from "store/actions/selfInvoiceActions";
//#endregion
//#region types
import { ActionButton } from "models/propTypes/commonPropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { SelfInvoiceFooterProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useInvoiceService, useSelfInvoiceService } from "serviceHooks";
import SelfInvoiceMoreActions from "./moreActions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceFooter: React.FC<SelfInvoiceFooterProps> = (props) => {
  const { id, draftCustomerInvoiceId, submitInvoice, markAsDoneHandler, disableActions } = props;

  const selfInvoiceService = useSelfInvoiceService();
  const invoiceService = useInvoiceService();

  const dispatch = useDispatch();

  const onReject = async () => selfInvoiceService.reject(id);

  const onAccept = async () => {
    await submitInvoice();
    await selfInvoiceService.markAsSubmitted(id);
  };

  const onAcceptedSuccess = () => {
    dispatch(selfInvoiceSent(id));
    markAsDoneHandler();
  };

  const onRejectSuccess = () => {
    dispatch(selfInvoiceDiscarded(id));
    if (draftCustomerInvoiceId) {
      invoiceService.deleteInvoice(draftCustomerInvoiceId);
    }
    markAsDoneHandler();
  };

  const getActions = () => {
    const actions: ActionButton[] = [];

    actions.push({
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reject),
      onClick: onReject,
      type: StyleEnums.DisplayType.Danger,
      onActionSuccess: onRejectSuccess,
      isDisabled: disableActions,
    });
    actions.push({
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve),
      onClick: onAccept,
      type: StyleEnums.DisplayType.Success,
      onActionSuccess: onAcceptedSuccess,
      isDisabled: disableActions,
    });

    return actions;
  };

  return (
    <PageFooter
      actions={getActions()}
      moreActions={
        <SelfInvoiceMoreActions
          id={id}
          markAsDoneHandler={markAsDoneHandler}
          disableSuccessMessages={props.disableSuccessMessages}
        />
      }
      disableSuccessMessages={props.disableSuccessMessages}
    />
  );
};

export default SelfInvoiceFooter;
